import { http } from "../client";
var isForgotPasswordFailure = function (error) {
    var _a, _b;
    return (_b = (_a = error === null || error === void 0 ? void 0 : error.response) === null || _a === void 0 ? void 0 : _a.data) === null || _b === void 0 ? void 0 : _b.errors;
};
export var forgotPassword = function (email) {
    return http.base
        .post("/forgot-password", { email: email })
        .then(function () { return ({ type: "success" }); })
        .catch(function (error) {
        if (isForgotPasswordFailure(error)) {
            return { type: "failure", errors: error.response.data.errors };
        }
        return Promise.reject(error);
    });
};
